import { render, staticRenderFns } from "./cums.vue?vue&type=template&id=5c802bda&"
import script from "./cums.vue?vue&type=script&lang=js&"
export * from "./cums.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports